// Temporary disable eslint warnings until real API is used.
/* eslint-disable */
import axios, { AxiosError } from 'axios'
import config from 'config'

export interface DecisionType {
    status: string
}

export default async function getSplitDecision(uuid: string) {
    try {
        const { data } = await axios.get(
            `${config.API_BASE_URL}/api/v3/client-application/${uuid}/decision/`,
            {
                withCredentials: true,
            },
        )

        return data as DecisionType
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const axiosError = error as AxiosError

        throw new Error(axiosError.message)
    }
}
